import React from 'react';
import styles from './Banner.module.scss';
import { useDesktopQuery } from '../../../Hooks';

export interface BannerProps {
  banner: string;
  brand: string;
}

export const Banner = ({
  banner,
  brand
}: BannerProps): React.ReactElement<BannerProps> => {
  const isDesktop = useDesktopQuery();

  return (
    <div
      className={styles.banner}
      style={{ backgroundImage: isDesktop ? `url(${banner})` : 'none' }}
    >
      <h1>
        <img className={styles.brand} src={brand} alt="Brand" />
      </h1>
    </div>
  );
};
